import { render, staticRenderFns } from "./groupBuying.vue?vue&type=template&id=249b8727&scoped=true"
import script from "./groupBuying.vue?vue&type=script&lang=js"
export * from "./groupBuying.vue?vue&type=script&lang=js"
import style0 from "./groupBuying.vue?vue&type=style&index=0&id=249b8727&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "249b8727",
  null
  
)

export default component.exports